export default __webpack_public_path__ + "static/media/grooming-cert.42308ee6.png";